import React from 'react';
import { IoCalendarClearOutline } from 'react-icons/io5';

const Calendar = (props) => {
  const { className } = props;
  return <IoCalendarClearOutline className={className} />;
};

export default Calendar;
